import React, { useState, useEffect } from 'react';
import { API_ENDPOINTS } from '../../utils/apiConfig';
import EntityHistory from './EntityHistory';
import ActivityIcon from './ActivityIcon';

const AuditTab = ({ token, dateRange }) => {
  const [audit, setAudit] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ entityType: '', userId: '', entityId: '' });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [expandedRow, setExpandedRow] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState(null); // Pour afficher l'historique complet

  // Charger la liste des utilisateurs
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINTS.BASE_URL}/api/users`,
          { headers: { 'Authorization': `Bearer ${token}` } }
        );
        const result = await response.json();
        if (result.success) {
          setUsers(result.data || []);
        }
      } catch (err) {
        console.error('Erreur chargement utilisateurs:', err);
      }
    };
    fetchUsers();
  }, [token]);

  useEffect(() => {
    const fetchAudit = async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams({
          page: page.toString(),
          limit: '50',
          ...(filters.entityType && { entityType: filters.entityType }),
          ...(filters.userId && { userId: filters.userId })
        });

        const response = await fetch(
          `${API_ENDPOINTS.BASE_URL}/api/analytics/dashboard/audit?${params}`,
          { headers: { 'Authorization': `Bearer ${token}` } }
        );
        const result = await response.json();

        if (result.success && result.data.available) {
          setAudit(result.data.audit);
          setTotalPages(result.data.totalPages);
        }
      } catch (err) {
        console.error('Erreur chargement audit:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAudit();
  }, [token, page, filters]);

  // Si une entité est sélectionnée, afficher son historique complet
  if (selectedEntity) {
    return (
      <div>
        {/* Bouton retour */}
        <button
          onClick={() => setSelectedEntity(null)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '10px 16px',
            background: '#f8f9fa',
            border: '1px solid #dee2e6',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            marginBottom: '16px',
            color: '#495057'
          }}
        >
          <span>←</span>
          <span>Retour à l'audit</span>
        </button>

        {/* Header entité */}
        <div style={{
          background: 'white',
          borderRadius: '12px',
          padding: '16px 20px',
          marginBottom: '16px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
          display: 'flex',
          alignItems: 'center',
          gap: '16px'
        }}>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            background: '#fff3e0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px'
          }}>
            📜
          </div>
          <div>
            <div style={{ fontWeight: '600', fontSize: '16px' }}>
              {selectedEntity.entityLabel || `${selectedEntity.entityType} #${selectedEntity.entityId}`}
            </div>
            <div style={{ fontSize: '13px', color: '#666' }}>
              Historique complet de l'entité
            </div>
          </div>
          <span style={{
            marginLeft: 'auto',
            padding: '4px 12px',
            borderRadius: '12px',
            fontSize: '12px',
            background: '#e3f2fd',
            color: '#1976d2',
            textTransform: 'capitalize'
          }}>
            {selectedEntity.entityType}
          </span>
        </div>

        {/* Historique de l'entité */}
        <EntityHistory
          entityType={selectedEntity.entityType}
          entityId={selectedEntity.entityId}
          token={token}
          limit={100}
          showHeader={false}
        />
      </div>
    );
  }

  return (
    <div>
      {/* Filtres */}
      <div style={{ marginBottom: '20px', display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center' }}>
        <select
          value={filters.entityType}
          onChange={(e) => setFilters(f => ({ ...f, entityType: e.target.value }))}
          style={{ padding: '8px 12px', border: '1px solid #ddd', borderRadius: '8px' }}
        >
          <option value="">Toutes les entites</option>
          <option value="user">Utilisateurs</option>
          <option value="prestation">Prestations</option>
          <option value="group">Groupes</option>
          <option value="client">Clients</option>
          <option value="location">Lieux</option>
          <option value="expense">Notes de frais</option>
          <option value="leave_request">Demandes congés</option>
        </select>
        <input
          type="text"
          placeholder="ID entité..."
          value={filters.entityId}
          onChange={(e) => setFilters(f => ({ ...f, entityId: e.target.value }))}
          style={{ padding: '8px 12px', border: '1px solid #ddd', borderRadius: '8px', width: '120px' }}
        />
        <select
          value={filters.userId}
          onChange={(e) => setFilters(f => ({ ...f, userId: e.target.value }))}
          style={{ padding: '8px 12px', border: '1px solid #ddd', borderRadius: '8px', minWidth: '180px' }}
        >
          <option value="">Tous utilisateurs</option>
          {users.map(user => (
            <option key={user.id} value={user.id}>
              {user.first_name} {user.last_name}
            </option>
          ))}
        </select>
        {(filters.entityType || filters.entityId || filters.userId) && (
          <button
            onClick={() => setFilters({ entityType: '', userId: '', entityId: '' })}
            style={{
              padding: '8px 12px',
              background: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            Effacer filtres
          </button>
        )}
      </div>

      {/* Liste audit */}
      <div style={{
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
      }}>
        {loading ? (
          <div style={{ padding: '40px', textAlign: 'center' }}>Chargement...</div>
        ) : audit.length === 0 ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>
            Aucune entree d'audit
          </div>
        ) : (
          audit.map((entry, idx) => (
            <div
              key={entry.id}
              style={{
                padding: '16px 20px',
                borderBottom: idx < audit.length - 1 ? '1px solid #eee' : 'none'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <ActivityIcon type={entry.event_type} size="medium" />
                <div
                  style={{ flex: 1, cursor: 'pointer' }}
                  onClick={() => setExpandedRow(expandedRow === entry.id ? null : entry.id)}
                >
                  <div style={{ fontWeight: '500' }}>
                    {entry.entity_label || entry.event_name}
                    <span style={{
                      marginLeft: '8px',
                      fontSize: '12px',
                      color: '#666',
                      fontWeight: 'normal'
                    }}>
                      {entry.entity_type} #{entry.entity_id}
                    </span>
                  </div>
                  <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                    par {entry.user_name || 'Systeme'} - {new Date(entry.created_at).toLocaleString('fr-FR')}
                  </div>
                </div>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedEntity({
                      entityType: entry.entity_type,
                      entityId: entry.entity_id,
                      entityLabel: entry.entity_label
                    });
                  }}
                  style={{
                    padding: '4px 10px',
                    background: '#e3f2fd',
                    color: '#1976d2',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '11px',
                    fontWeight: '500',
                    whiteSpace: 'nowrap'
                  }}
                  title="Voir l'historique complet de cette entité"
                >
                  Historique
                </button>
                <span
                  style={{ color: '#999', cursor: 'pointer', padding: '4px' }}
                  onClick={() => setExpandedRow(expandedRow === entry.id ? null : entry.id)}
                >
                  {expandedRow === entry.id ? '▼' : '▶'}
                </span>
              </div>

              {/* Details (expanded) */}
              {expandedRow === entry.id && (entry.old_values || entry.new_values) && (
                <div style={{
                  marginTop: '16px',
                  padding: '16px',
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '16px'
                }}>
                  <div>
                    <div style={{ fontWeight: '600', marginBottom: '8px', color: '#dc3545' }}>
                      Anciennes valeurs
                    </div>
                    <pre style={{
                      fontSize: '12px',
                      background: 'white',
                      padding: '8px',
                      borderRadius: '4px',
                      overflow: 'auto',
                      maxHeight: '200px'
                    }}>
                      {JSON.stringify(entry.old_values, null, 2) || 'null'}
                    </pre>
                  </div>
                  <div>
                    <div style={{ fontWeight: '600', marginBottom: '8px', color: '#28a745' }}>
                      Nouvelles valeurs
                    </div>
                    <pre style={{
                      fontSize: '12px',
                      background: 'white',
                      padding: '8px',
                      borderRadius: '4px',
                      overflow: 'auto',
                      maxHeight: '200px'
                    }}>
                      {JSON.stringify(entry.new_values, null, 2) || 'null'}
                    </pre>
                  </div>
                </div>
              )}
            </div>
          ))
        )}

        {/* Pagination */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '8px',
          padding: '16px',
          borderTop: '1px solid #eee'
        }}>
          <button
            onClick={() => setPage(p => Math.max(1, p - 1))}
            disabled={page === 1}
            style={{
              padding: '8px 16px',
              border: '1px solid #ddd',
              borderRadius: '8px',
              cursor: page === 1 ? 'not-allowed' : 'pointer',
              opacity: page === 1 ? 0.5 : 1,
              background: 'white'
            }}
          >
            Precedent
          </button>
          <span style={{ padding: '8px 16px', color: '#666' }}>
            Page {page} / {totalPages || 1}
          </span>
          <button
            onClick={() => setPage(p => Math.min(totalPages, p + 1))}
            disabled={page === totalPages || totalPages === 0}
            style={{
              padding: '8px 16px',
              border: '1px solid #ddd',
              borderRadius: '8px',
              cursor: page === totalPages || totalPages === 0 ? 'not-allowed' : 'pointer',
              opacity: page === totalPages || totalPages === 0 ? 0.5 : 1,
              background: 'white'
            }}
          >
            Suivant
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuditTab;
